module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('h1', [_vm._v("城市大共享计划")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pic mar1"
  }, [_c('img', {
    attrs: {
      "src": _vm.src2
    }
  }), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text mar1"
  }, [_c('p', [_vm._v("ofo 共享单车以开放平台和共享精神")]), _vm._v(" "), _c('p', [_vm._v("接纳每一颗热衷共享的种子")]), _vm._v(" "), _c('p', [_vm._v("一同繁衍它的“城市大共享计划”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ad"
  }, [_c('h3', [_vm._v("连接单车"), _c('br'), _vm._v("但不生产单车")]), _vm._v(" "), _c('p', {
    staticClass: "word"
  }, [_vm._v("ofo，不断连接更多优秀的单车品牌与生产商，接入更多产品线来满足用户的多元需求，共同提供城市出行服务。")]), _vm._v(" "), _c('p', {
    staticClass: "word"
  }, [_vm._v("同时，ofo 欢迎用户共享自己的单车，加入“城市大共享计划”，以 1 换 N ，提升闲置单车的使用效率。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c2c10dda"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/shareContent.vue
// module id = 26
// module chunks = 0